const parseNullString = (value: string): string | null => (value.trim() === '' ? null : value);
const formatNull = (value: string | null): string => (value === null ? '' : value);

export const coerceNullProps = {
  parse: parseNullString,
  format: formatNull,
};
